import { unitMapping, type Unit } from '#src/lib/style.ts';

type Props = {
  size?: Unit;
  className?: string;
};
export const StreakFire = ({ className, size = 4 }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="24"
      viewBox="0 0 18 24"
      fill="none"
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      className={className}
    >
      <path
        d="M0.923051 14.9492C0.216633 20.0074 4.58472 22.9202 6.85707 23.7444C4.50628 21.9199 5.0831 20.0257 5.33325 19.2042L5.33826 19.1878C5.58552 18.3754 6.46857 16.8565 7.10437 15.4789C7.74017 14.1014 8.02274 13.7482 8.83515 13.7128C9.64756 13.6775 9.93014 13.9248 10.354 14.4546C10.7779 14.9844 11.7316 16.6799 12.6499 19.1878C13.3846 21.1941 12.179 22.8024 11.4843 23.3558C18.3368 19.0112 17.807 14.4899 15.5817 9.72143C13.8014 5.90664 9.56514 1.79746 7.66952 0.219727C7.75429 2.98898 5.98583 6.01256 5.091 7.17819C4.66714 6.47175 4.46698 3.84621 4.41988 2.62175C3.54861 4.62332 1.62947 9.89102 0.923051 14.9492Z"
        fill="url(#paint0_linear_20203_10)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_20203_10"
          x1="8.96063"
          y1="0.219727"
          x2="8.96063"
          y2="23.7444"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF5021" />
          <stop offset="0.220944" stopColor="#FCCD21" />
          <stop offset="0.837695" stopColor="#9D2A1D" />
        </linearGradient>
      </defs>
    </svg>
  );
};
